import { User } from 'lib';
import store from 'store';

export type ParamTypes = 'DefaultNewOrderView' | 'DefaultNewOrderViewMobile' | 'DefWindow' | 'DefZamPageCount';

export const NEW_ORDER_VIEW = 'DefaultNewOrderView';
export const NEW_ORDER_VIEW_MOBILE = 'DefaultNewOrderViewMobile';
export const DEF_WINDOW = 'DefWindow';
export const ORD_PAGE_COUNT = 'DefZamPageCount';
export const MIN_PASSWORD_LENGTH = 8;

const getUser = (): User | null => store.getState().session.user;

export const userService = {
    getUser
};
